import { createSlice } from "@reduxjs/toolkit";
import helper from "../../Helper";
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
  loading: false,
  getUserbankDetails: [],

  getUserbanknamelist: [],
  getAdminbanknamelist: [],
  AddDepositres: [],
  AddWithdrawres: [],

  userBankListsRes: [],

  Verifywithdrawres: [],

  UpdateBankDetails: [],
  DeleteBankDetails: [],
  error: "",
};


// CONFIRM_WITHDRAW


const bankDetailsSlice = createSlice({
  name: "bankDetails",
  initialState,
  reducers: {
    getuserbankdet: (state, action) => {
      state.getUserbankDetails = action.payload;
    },

    getuserbankname: (state, action) => {
      state.getUserbanknamelist = action.payload;
    },
    getadminbankname: (state, action) => {
      state.getAdminbanknamelist = action.payload;
    },

    addDeposit: (state, action) => {
      state.AddDepositres = action.payload;
    },

    addWithdraw: (state, action) => {
      state.AddWithdrawres = action.payload;
    },

    verifyWithdraw: (state, action) => {
      state.Verifywithdrawres = action.payload;
    },
    userBankLists: (state, action) => {
      state.userBankListsRes = action.payload;
    },
    updateBankLists: (state, action) => {
      state.UpdateBankDetails = action.payload;
    },
    deleteBankLists: (state, action) => {
      state.DeleteBankDetails = action.payload;
    }
  },
});

export const { getuserbankdet, getuserbankname, deleteBankLists, updateBankLists, userBankLists, addDeposit, getadminbankname, addWithdraw, verifyWithdraw } =
  bankDetailsSlice.actions;
export default bankDetailsSlice.reducer;

export const getUserbankDetails =
  (data, type, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API.GET_USER_BANK_DETAILS}`, data
          , type
        );
        callback(response);
        dispatch(getuserbankdet(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };
export const addDepositreq =
  (data, type, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API.ADD_DEPOSIT_REQUEST}`,
          data, type
        );
        callback(response);
        dispatch(addDeposit(response));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const addWithdrawreq =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API?.WITHDRAW_REQUEST}`,
          data
        );
        callback(response);
        dispatch(addWithdraw(response));
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const verifyWithdrawreq =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API?.CONFIRM_WITHDRAW}`,
          data
        );
        callback(response);
        dispatch(verifyWithdraw(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };


export const getAdminbankdetails =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API?.GET_ADMIN_BANK_NAME}`,
          data
        );

        callback(response);
        dispatch(getadminbankname(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getUserbank =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.GetData(
          `${frontUrl}/${API?.GET_USER_BANK_NAME}`
        );
        callback(response);
        dispatch(getuserbankname(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };


export const getUserBankLists = (data, callback = () => { }) =>
  async (dispatch) => {
    try {
      const response = await helper.PostData(
        `${frontUrl}/${API?.GET_BANK_DETAILS_LISTS}`, data
      );
      callback(response);
      dispatch(userBankLists(response?.data));
      return response.data;
    } catch (e) {
      return console.error(e.message);
    }
  };


export const updateBankList = (data, type, callback = () => { }) =>
  async (dispatch) => {
    try {
      const response = await helper.PostData(

        `${frontUrl}/${API?.UPDATE_BANK_DETAILS}`, data, type
      );
      callback(response);

      dispatch(updateBankLists(response?.data));
      return response.data;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const deleteBank = (data, callback = () => { }) =>
  async (dispatch) => {
    try {
      const response = await helper.PostData(
        `${frontUrl}/${API?.DELETE_BANK_DETAILS}`, data
      );
      callback(response);
      dispatch(deleteBankLists(response?.data));
      return response.data;
    } catch (e) {
      return console.error(e.message);
    }
  };
